import { Icon } from 'aos-ui-universal'
import { baseIcons } from 'aos-ui-universal/src/icons/compiled'
import React, { CSSProperties, FC } from 'react'

interface InspectionSelectedCounterProps {
    selectedInspectionsCounter: number
    inspectionTotalNumber: number
}

export const InspectionSelectedCounter: FC<InspectionSelectedCounterProps> = ({
    inspectionTotalNumber,
    selectedInspectionsCounter,
}) => (
    <div style={blockStyle}>
        <span style={spanStyles}>{selectedInspectionsCounter + '/' + inspectionTotalNumber}</span>
        <Icon as={baseIcons.CheckboxChecked} size={8} className='ml-0.5 align-middle' />
    </div>
)

const blockStyle: CSSProperties = {
    position: 'absolute',
    top: '4px',
    right: '4px',
    lineHeight: 0,
}

const spanStyles: CSSProperties = {
    fontSize: '8px',
    verticalAlign: 'middle',
}
